import { Component, OnInit } from '@angular/core';
import { CustomerService } from 'src/app/services/customer.service';
import { Customer } from 'src/app/models/customer';
import { TravelRouteService } from 'src/app/services/travel-route.service';
import { TravelRoute } from 'src/app/models/travel-route';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilitiesService } from 'src/app/services/utilities.service';

import * as _ from 'lodash';
import { ExpenseService } from 'src/app/services/expense.service';
import { ExpenseRoute } from 'src/app/expense-route';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin } from 'rxjs';
import { Expense } from 'src/app/models/expense';
import { ExpenseType } from 'src/app/models/expense-type';

@Component({
  selector: 'app-route-new',
  templateUrl: './route-new.component.html',
  styleUrls: ['./route-new.component.css']
})
export class RouteNewComponent implements OnInit {
  customer:Customer = {
    account_number: '',
    active: false,
    colony: '',
    comercial_name: '',
    directions: [],
    email: '',
    id: 0,
    locality: '',
    name: '',
    phone_number: '',
    rfc: '',
    state: '',
    street: '',
    type: '',
    zip_code: 0,
    contact: '',
    contact_email: '',
    
  };
  customers:Customer[] = [];
  loading:boolean = false;
  routes:TravelRoute[] = [];
  
  // New data
  public find:string = '';
  public routesTemp:TravelRoute[] = [];
  travelExpenses: ExpenseRoute[] = [];
  routeName: string = '';
  gas: number = 0;
  meters: number = 0;
  time: number = 0;
  price: number = 0;
  expense_type_id: number = 0;
  expense_id: number = 0;
  origin:{
    lat:number,
    lng:number,
  };
  destination:{
    lat:number,
    lng:number,
  };
  routeExpenses:any[] = [];
  expense:any;
  typeExpenses: ExpenseType[] = [];
  expenseTypesMaps:any = [];
  expenses:Expense[] = [];
  expensesAll: Expense[] = [];
  expensesMaps:any = [];
  route:any;
  searchedCustomerName:string = '';
  expenseDisabled = false;
  constructor(
    private custServ:CustomerService, private routeServ:TravelRouteService, private toastr: ToastrManager, private utl: UtilitiesService, private servExpense: ExpenseService
    ,private modalService: NgbModal
  ) { }
  ngOnInit() {
    this.loading = true;
    this.custServ.getCustomers().then(customers => {
      this.customers = customers.filter(x => x.type != 'Compañia');
      this.customer = this.customers[0];
      this.loading = false;
      this.getData();
    });
  }
  getData(){
    this.loading = true;
    forkJoin([this.servExpense.getExpenseTypes(), this.servExpense.getExpenses()]).subscribe(([expeType, expensess]) => {
      this.typeExpenses = expeType;
      _.forEach(this.typeExpenses, (et) => { this.expenseTypesMaps.push({id: et.id, text: et.name}); });
      this.expense_type_id = this.expenseTypesMaps[0].id;
      this.expenses = expensess;
      this.expensesAll = this.expenses;
      this.expenses = this.expenses.filter(b => b.expense_type_id == this.expense_type_id);
      _.forEach(this.expenses, (ex) => { this.expensesMaps.push({id: ex.id, text: ex.name}); });
      this.expense_id = (this.expensesMaps.length > 0) ? this.expensesMaps[0].id : 0;
      this.expenseDisabled = this.expensesMaps.length === 0;
      this.loading = false;
    }, error => {
      this.toastr.warningToastr('Ocurrió un error al obtener los datos del viaje a actualizar.', '', {enableHTML: true});
      this.loading = false;
    });
  }
  search() {
    this.loading = true;
    this.routeServ.getByCustomerSimple(this.customer).then(routes => {
      this.searchedCustomerName = this.customer.name;
      this.routes = routes;
      this.filter(); 
      this.loading = false;
    });
  }
  filter(){
    this.searchTable(this.routes, 
      // Search columns
      [
        'name',
        'target_customer.name',
        'source_customer.name', 
        
        'source_customer_address.name', 
        'source_customer_address.street', 
        'source_customer_address.colony', 
        'source_customer_address.city', 
        'source_customer_address.zip_code', 
        'source_customer_address.locality', 
        'source_customer_address.state',

        'target_customer_address.name', 
        'target_customer_address.street', 
        'target_customer_address.colony', 
        'target_customer_address.city', 
        'target_customer_address.zip_code', 
        'target_customer_address.locality', 
        'target_customer_address.state',
      ], this.find, routes => this.routesTemp = routes
    );
  }
  searchTable(data, columns, find, callback) {

    const search = find.toLocaleLowerCase().trim();
    if (!search) {
      callback(data);
      return;
    }

    const filtered = _.filter(data, da => {
      return columns.some(col => {

        const value = col.split('.').reduce((obj, key) => {
          return obj != null ? obj[key] : null;
        }, da);

        return value != null &&
          value.toString()
            .toLocaleLowerCase()
            .includes(search);
      });
    });
    callback(filtered);
  }
  getAddressString(addr) {
    return addr.street + ', ' + addr.colony + ', ' + addr.city + ', C.P.: ' + addr.zip_code + ', ' + addr.locality + ', ' + addr.state;
  }
  openModal(modal){
    this.modalService.open(modal, { size: 'lg', windowClass: 'bigger' });
  }
  openRoute(modal,route){
    this.loading = true;
    this.expense = null;
    this.origin =  {
      lat: Number(route.source_customer_address.latitude),
      lng: Number(route.source_customer_address.longitude),
    };
    this.destination =  {
      lat: Number(route.target_customer_address.latitude),
      lng: Number(route.target_customer_address.longitude),
    };
    this.routeServ.getExpensesByRoute(route.id).then(expenses => {
      this.routeExpenses = expenses;
      this.loading = false;
      this.openModal(modal);
    });
  }
  updateRoute(modal, route){
    this.loading = true;
    this.route = route;
    
    this.servExpense.getExpenseByRoute(route.id).then(response => {
      this.travelExpenses = response;
      this.loading = false;
      if (this.travelExpenses.length > 0) {
        this.routeName = this.travelExpenses[0].route_name;
        this.meters = this.travelExpenses[0].meters;
        this.time = this.travelExpenses[0].time;
        this.gas = this.travelExpenses[0].gas;
      }
      this.openModal(modal);
    }, error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      this.loading = false;
    });
  }
  selectTypeExpense(event){
    if(event['value'] != null){
      this.expense_type_id = event['value'];
      // let expenseHTML = (<HTMLInputElement>document.getElementById('expense_id'));
      this.expenses = this.expensesAll.filter(e => e.expense_type_id == this.expense_type_id);
      this.expensesMaps = [];
      _.forEach(this.expenses, (e) =>{ this.expensesMaps.push({id: e.id, text: e.name}); });
      // expenseHTML.disabled = (this.expensesMaps.length > 0) ? false : true; //Sino trae gastos, entonces deshabilitamos
      this.expenseDisabled = this.expensesMaps.length === 0;
    }
  }
  selectExpense(event){
    if(event['value'] != null){
      this.expense_id = event['value'];
      this.price = this.expenses.find(e => e.id == this.expense_id).price;
      const expense = this.expenses.find(e => e.id == this.expense_id);
      this.price = expense ? expense.price : 0;

    }
  }
  deleteExpense(id: number, expense_id: number){
    let travelExp = this.travelExpenses.filter(te => te.expense_id != expense_id);
    this.travelExpenses = travelExp;
  }
  addExpense(){
    if(!this.travelExpenses.find(e => e.expense_id == this.expense_id)){
      if(this.expense_type_id && this.expense_id && this.price){
        this.loading = true;
        let newExpenseRoute = new ExpenseRoute;
        newExpenseRoute.id = this.route.id;
        newExpenseRoute.route_name = this.route.name;
        newExpenseRoute.expense_id = this.expense_id;
        newExpenseRoute.expense_name = this.expensesAll.find(e=> e.id == this.expense_id).name;
        newExpenseRoute.price = this.price;
        newExpenseRoute.expense_type_id = this.expense_type_id;
        newExpenseRoute.expense_type = this.expensesAll.find(e => e.expense_type_id == this.expense_type_id).expense_type.name;
        newExpenseRoute.type = this.expensesAll.find(e => e.expense_type_id == this.expense_type_id).expense_type.type;
        this.travelExpenses.push(newExpenseRoute);
        this.loading = false;
      }else{ this.toastr.infoToastr('Debes completar los campos necesarios.', '', {enableHTML: true}); }
    }else{ this.toastr.infoToastr('Este gastos ya ha sido agregado a la ruta. Elije otro.', '', {enableHTML: true}); }
  }
  updateTravelRoute(){
    this.loading = true;
    if(this.travelExpenses.length > 0){
      //Actualizar Rutas
      let meters = this.meters;
      let time = this.time;
      let gas = this.gas;
      _.forEach(this.travelExpenses, (te) => {
        te.meters = meters;
        te.time = time;
        te.gas = gas;
      });
      this.travelExpenses[0].route_name = this.routeName;
      this.servExpense.updateExpensesRoute(this.route.id, this.travelExpenses).then(response => {
        this.travelExpenses = response;
        this.loading = false;
        this.defaultValues();
        this.modalService.dismissAll();
        this.onEventLaunched("La ruta fue actualizada correctamente!!!");
      }, error => {
        this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
        this.loading = false;
      });
    }else{ this.toastr.infoToastr('Debes agregar por lo menos un gasto a la ruta.', '', {enableHTML: true}); }
  }
  onEventLaunched(event) {
    this.toastr.successToastr(event, '', {enableHTML: true});
    this.search();
  }
  defaultValues(){
    this.price = 0;
    this.meters = 0;
    this.time = 0;
    this.gas = 0;
    this.travelExpenses = [];
    this.expense_type_id = 0;
    this.route = null;
    this.expense_id = 0;
    this.routeName = '';
  }
  download() {
    this.loading = true;

    const params = {
      excelHeaders: [
        "Nombre",
        "Ruta Origen",
        "Ruta Destino",
        "Alias Origen",
        "Alias Destino",
        "Direccion Origen",
        "Direccion Destino"
      ],
      data: this.routesTemp.map(route => [
        route.name,
        route.source_customer.name,
        route.target_customer.name,
        route.source_customer_address.name,
        route.target_customer_address.name,
        this.getAddressString(route.source_customer_address),
        this.getAddressString(route.target_customer_address)
      ]),
      title: 'Rutas:' + this.searchedCustomerName +' .xlsx'
    }

    this.routeServ.getRouteExcel(params).then(response => {
      const blob = new Blob([response],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = params.title;
      a.click();
      window.URL.revokeObjectURL(url);
      this.loading = false;
    }).catch(error => {
      this.toastr.errorToastr(this.utl.formatMessages(error),'',{ enableHTML: true });
      this.loading = false;
    });

  }
}
